import ErrorContent from '@/pages/Errors/components/ErrorContent';
import {AuthContext} from '@/context/Auth/AuthContext';
import {useContext, useState} from 'react';
import PropTypes from 'prop-types';

export const PageError403 = ({error}) => {
  const [isLoading, setIsLoading] = useState(false);
  const {signOut} = useContext(AuthContext);

  const onClickReturn = () => {
    setIsLoading(true);
    signOut();
  };

  return (
    <>
      <p className='mt-4 w-full text-center'>{error?.message}</p>
      <ErrorContent
        errorType='FORBIDDEN'
        isLoading={isLoading}
        onClick={onClickReturn}
      />
    </>
  );
};

PageError403.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string
  })
};

PageError403.defaultProps = {
  error: null
};
